import DepreciationClassesTable from './DepreciationClassesTable'

export default DepreciationClassesTable
